
import Vue from "vue";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import { BrowserClient } from "@sentry/browser";

const config = {
  dsn: process.env.MIX_SENTRY_DSN,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  environment: process.env.NODE_ENV,

  /**
   * Errors thrown by scripts injected in the page by Safari / iOS browser
   * extensions and in-app web views. They never originate from our code and
   * cannot be fixed on our side.
   */
  ignoreErrors: [
    // iOS WKWebView (in-app browsers, extensions) message bridge
    "WKWebView API client did not respond to this postMessage",
    // Safari extensions (source is masked as @webkit-masked-url://hidden/)
    "undefined is not an object (evaluating 'response.innerHTML')"
  ],
  denyUrls: [
    /webkit-masked-url:\/\//i,
    /^safari-(web-)?extension:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i
  ]
};

const client = new BrowserClient(config);

// Only init in prod
if (process.env.NODE_ENV == "production") {
  Sentry.init(config);
}

export default client;
